import React, { useEffect, useState } from 'react';
import { t, Trans } from '@lingui/macro';
import { FormData } from './Wizard';

type Props = {
    formData: FormData;
    handleChange?: any;
    isValid?: any;
}

const Step3 = ({ formData, handleChange, isValid }: Props) => {
    const [question, setQuestion] = useState('');

    useEffect(() => {

        isValid(false);
        if (formData.questionThree !== '') {
            isValid(true);
        }

        if (formData.questionOne === '1.1') {
            switch (formData.questionTwo) {
                case '2.1':
                    setQuestion(t({ id: 'q3.1.1', message: 'Does the computer, where the license shall be activated, have internet access?' }));
                    break;
                case '2.2':
                    setQuestion(t({ id: 'q3.1.2', message: 'Does the license server, where the license shall be activated, have internet access?' }));
                    break;
                default:
                    setQuestion('');
            }
        } else if (formData.questionOne === '1.2') {
            switch (formData.questionTwo) {
                case '2.1':
                    setQuestion(t({ id: 'q3.2.1', message: 'Does the computer, where the license is currently installed, have internet access?' }));
                    break;
                case '2.2':
                    setQuestion(t({ id: 'q3.2.2', message: 'Does the license server, where the license is currently installed, have internet access?' }));
                    break;
                default:
                    setQuestion('');
            }
        } else if (formData.questionOne === '1.3') {
            switch (formData.questionTwo) {
                case '2.1':
                    setQuestion(t({ id: 'q3.3.1', message: 'Does the computer, where the license is currently installed, have internet access?' }));
                    break;
                case '2.2':
                    setQuestion(t({ id: 'q3.3.2', message: 'Does the license server, where the license is currently installed, have internet access?' }));
                    break;
                default:
                    setQuestion('');
            }
        }
    }, [formData, isValid]);


    const onChange = (value: string) => {
        if (handleChange) {
            const data = {
                ...formData,
                'questionThree': value,
            }
            handleChange(data);
        }
    }

    return (
        <>
            {formData.questionTwo === '2.3' ?
                <div className="content">
                    <p className="my-1"><span className="fw-bold text-purple"><Trans>Instructions</Trans>:</span></p>
                    <p><Trans>For cloud licenses, PTV does the license management for you, i.e., we activate and update your licenses directly in the cloud.</Trans></p>
                    <p><Trans>The only step required on your side is to prepare the license usage on the computers in your network. The following instructions tell you how to do that:</Trans></p>
                    <ul>
                        <li><a href={t`https://support.ptvgroup.com/en-us/knowledgebase/article/KA-05572`} rel="noreferrer" target="_blank"><Trans>Using a PTV Hub license</Trans></a></li>
                        <li><a href={t`https://support.ptvgroup.com/en-us/knowledgebase/article/KA-05342`} rel="noreferrer" target="_blank"><Trans>Using a license from a cloud container</Trans></a></li>
                    </ul>
                </div>
                :
                <>
                    <p className="my-1"><span className="fw-bold text-purple"><Trans id="h3">Question 3</Trans>:</span></p>
                    <div className='mt-2'><strong>{question}</strong></div>
                    <div className="pb-3">
                        <div className="mb-3 form-check custom-radio">
                            <input
                                className="form-check-input custom-control-input float-start"
                                type="radio"
                                name="q3"
                                value="3.1"
                                id="3.1"
                                checked={formData.questionThree === '3.1'}
                                onChange={(value) => onChange('3.1')}
                            />
                            <label className="form-check-label custom-control-label" htmlFor="3.1"><Trans>yes</Trans></label>
                        </div>
                        <div className="mb-3 form-check custom-radio">
                            <input
                                className="form-check-input custom-control-input float-start"
                                type="radio"
                                name="q3"
                                value="3.2"
                                id="3.2"
                                checked={formData.questionThree === '3.2'}
                                onChange={(value) => onChange('3.2')}
                            />
                            <label className="form-check-label custom-control-label" htmlFor="3.2"><Trans>no</Trans></label>
                        </div>
                    </div>
                </>
            }
        </>
    );
}

export default Step3;